import { Paper, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { WidgetDef } from '../registry';

interface Props {
    def: WidgetDef;
    institutionId: string;
    editable: boolean;
    onRemove?: () => void;
}

export default function WidgetCard({ def, institutionId, editable, onRemove }: Props) {
    const { t } = useTranslation('dashboard');
    const Component = def.component;
    const title = t(def.titleKey);
    return (
        <Paper variant="outlined" sx={{ p: 2, height: '100%', position: 'relative', '&:hover .rm': { opacity: 1 } }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                    <Typography variant="subtitle2" fontWeight={700}>{title}</Typography>
                    {def.subtitleKey && (
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>{t(def.subtitleKey)}</Typography>
                    )}
                </Box>
                {editable && onRemove && (
                    <IconButton className="rm" size="small" aria-label={t('board.removeWidget', { title })} onClick={onRemove} sx={{ opacity: 0, transition: 'opacity .1s' }}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>
            <Component institutionId={institutionId} />
        </Paper>
    );
}
